import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaInvoiceData } from "@/src/types/admissionOffice";
import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";

const emptyInvoiceState = (): AOPMaltaInvoiceData => ({
  currentDate: "",
  fullName: "",
  dateOfBirth: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  duration: "",
  mediumOfInstruction: "",
  coursePrefix: "",
  invoiceBody: [],
});

export interface AOPInvoiceLetterBasicLayoutProps {
  country: AdmissionOfficeCountry;
}

const AOPInvoiceLetterBasicLayout = ({ country }: AOPInvoiceLetterBasicLayoutProps) => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaInvoiceData>(emptyInvoiceState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaInvoiceData>(emptyInvoiceState);
  const [withQR, setWithQR] = useState(true);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
        setWithQRForPreview={setWithQR}
      />
      <AOPPrev country={country} bodyForPrev={bodyForPrev} withQR={withQR} />
    </div>
  );
};

export default AOPInvoiceLetterBasicLayout;
